var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D4D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8995A0",
    d: "M8,10 C10.8946805,10 13.3789848,11.1295189 14.4446001,12.7403555 C12.9882174,14.7174596 10.6438854,16 8,16 C5.35611464,16 3.01178262,14.7174596 1.55522067,12.7405956 C2.62101519,11.1295189 5.1053195,10 8,10 Z M8,2 C9.65685425,2 11,3.56700338 11,5.5 C11,7.43299662 9.65685425,9 8,9 C6.34314575,9 5,7.43299662 5,5.5 C5,3.56700338 6.34314575,2 8,2 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEmpty);
export default __webpack_public_path__ + "static/media/profile_empty.352fb46e.svg";
export { ForwardRef as ReactComponent };